export default "__VITE_ASSET__2cb0fac3__"